import { Link } from "react-router-dom";
import { movieTitles, tvTitles } from "@/mocks/titles";

const entries = [
  {
    to: "/category/movie",
    label: "电影频道",
    en: "MOVIE",
    desc: "院线佳片、经典老片与高分之作，全部配有中文字幕。",
    count: movieTitles.length,
    icon: "ri-movie-2-line",
    accent: "from-accent-500/25",
  },
  {
    to: "/category/tv",
    label: "电视剧频道",
    en: "TV SERIES",
    desc: "热播剧集、年代大戏与悬疑刑侦，连载更新一目了然。",
    count: tvTitles.length,
    icon: "ri-tv-2-line",
    accent: "from-secondary-400/25",
  },
];

export default function CategoryEntry() {
  return (
    <section className="grid gap-3 px-4 py-8 md:grid-cols-2 md:gap-5 md:px-8 md:py-10">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative flex cursor-pointer items-center justify-between gap-4 overflow-hidden rounded-lg bg-primary-950 px-5 py-5 transition-colors hover:bg-primary-900 md:px-7 md:py-6"
        >
          <div className={`pointer-events-none absolute inset-0 bg-gradient-to-br ${entry.accent} via-transparent to-transparent`}></div>
          <div className="relative min-w-0">
            <p className="text-[11px] tracking-[0.22em] text-background-400">{entry.en}</p>
            <p className="mt-1.5 truncate font-heading text-xl font-semibold text-background-50 md:text-2xl">
              {entry.label}
            </p>
            <p className="mt-2 max-w-[420px] text-xs leading-6 text-background-300 md:text-[13px]">
              {entry.desc}
            </p>
            <p className="mt-3 flex items-center gap-1 text-xs text-accent-400">
              共 {entry.count} 部在库
              <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </p>
          </div>
          <span className="relative flex h-14 w-14 shrink-0 items-center justify-center rounded-lg border border-background-50/15 bg-background-50/5 md:h-16 md:w-16">
            <i className={`${entry.icon} text-2xl text-accent-400 md:text-3xl`} aria-hidden="true"></i>
          </span>
        </Link>
      ))}
    </section>
  );
}